import React, { Component } from 'react'
import { connect } from 'react-redux'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'

import { managerInfo } from 'selectors/manager'

let select = state => ({
	managerInfo: managerInfo(state)
})

export class ManagerContacts extends Component {
	state = { isOpen: false }
	toggleMenu = () => {
		this.setState({
			isOpen: !this.state.isOpen
		})
	}
	render(){
		let { props } = this
		return (
			<div className="manager-contacts" >
				<div
					className="manager-avatar"
					style={{
						display: "inline-block"
					  , margin: "0 10px"
					  , width: "30px"
					  , height: "30px"
					  , borderRadius: "100%"
					  , overflow: "hidden"
					  , float: "none"
					  , verticalAlign: "middle"
					  , background: `url(${props.managerInfo.avatar? props.managerInfo.avatar: "/landlord/static/img/res/avatar.png"})`
					  , backgroundSize: 'cover'
					  , backgroundPosition: "50%"
					  , cursor: "pointer"
					}}
					onClick={() => this.toggleMenu()}
				>
				</div>
				<div className="manager-name" style={{display: "inline-block", fontSize: "14px"}} >
					<div
						style={{
							display: "inline-block"
						  , cursor: "pointer"
						}}
						onClick={() => this.toggleMenu()}
					>
						<span style={{fontWeight: "bold"}} >{props.managerInfo.name}</span> is your manager
					</div>
					<IconMenu
						iconButtonElement={
							<IconButton style={{padding:"0", height:"24px", width:"24px", top:"8px",color: "white"}}>
								<i className="material-icons">
									keyboard_arrow_down
								</i>
							</IconButton>
						}
						anchorOrigin={{horizontal: 'left', vertical: 'top'}}
						targetOrigin={{horizontal: 'left', vertical: 'top'}}
						open={this.state.isOpen}
						onRequestChange={this.toggleMenu}
					>
						<a href={`tel:+${props.managerInfo.phone}`} style={{textDecoration: "none"}}><MenuItem
							primaryText={props.managerInfo.phone}
						/></a>
						<a href={`mailto:${props.managerInfo.email}`} style={{textDecoration: "none"}}><MenuItem
							primaryText={props.managerInfo.email}
						/></a>
					</IconMenu>
				</div>
			</div>
		)
	}
}

export default connect(select)(ManagerContacts)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/ManagerContacts.js